__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "meu-progresso-mfe-consumer";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-v3", "0.17.0", () => (Promise.all([__webpack_require__.e(514), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(3514))))));
			register("@sentry/browser", "7.119.1", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(658), __webpack_require__.e(264), __webpack_require__.e(883), __webpack_require__.e(539)]).then(() => (() => (__webpack_require__(2264))))));
			register("@sentry/browser", "7.120.4", () => (Promise.all([__webpack_require__.e(476), __webpack_require__.e(723), __webpack_require__.e(11)]).then(() => (() => (__webpack_require__(1723))))));
			register("@sentry/integrations", "7.119.1", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(790), __webpack_require__.e(658), __webpack_require__.e(267)]).then(() => (() => (__webpack_require__(4267))))));
			register("@sentry/integrations", "7.120.4", () => (Promise.all([__webpack_require__.e(790), __webpack_require__.e(476), __webpack_require__.e(753)]).then(() => (() => (__webpack_require__(753))))));
			register("@sentry/react", "7.119.1", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(720), __webpack_require__.e(318), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(7720))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(6710))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(6663))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			initExternal(5894);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};